import { Checkbox, Input, Select } from "antd";
import React, { useState } from "react";
import { CloseOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import "./stylesNewRouteModal.css";

function NewRouteModal({ handleCancel }) {
  const [formData, setFormData] = useState({
    name: "",
    card: null,
    minAmount: "",
    maxAmount: "",
    applyForAllPlayers: false,
    filterSegment: null,
    filterState: null,
    useDefaultPriority: false,
    processors: [
      {
        id: Date.now(),
        processor: null,
        noLimits: false,
        period: null,
        minTransactions: "",
        maxTotalAmount: "",
      },
    ],
  });

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleProcessorChange = (index, field, value) => {
    const updatedProcessors = [...formData.processors];
    updatedProcessors[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      processors: updatedProcessors,
    }));
  };

  const addProcessor = () => {
    setFormData((prev) => ({
      ...prev,
      processors: [
        ...prev.processors,
        {
          id: Date.now(),
          processor: null,
          noLimits: false,
          period: null,
          minTransactions: "",
          maxTotalAmount: "",
        },
      ],
    }));
  };

  const removeProcessor = (index) => {
    setFormData((prev) => ({
      ...prev,
      processors: prev.processors.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="new-route-modal-container">
      <div className="modal-header">
        <h2 className="modal-title">New Route</h2>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="basic-content">
        <div className="transaction-name">
          <span>Name</span>
          <Input
            type="text"
            value={formData.name}
            onChange={(e) => handleFieldChange("name", e.target.value)}
          />
        </div>
        <div className="transaction-info">
          <div className="transaction-info-item">
            <span>Card</span>
            <Select
              value={formData.card}
              onChange={(value) => handleFieldChange("card", value)}
              options={[
                { value: "Visa", label: "Visa" },
                { value: "Mastercard", label: "Mastercard" },
                { value: "American Express", label: "American Express" },
              ]}
            />
          </div>
          <div className="transaction-info-item">
            <span>Min. transaction amount</span>
            <Input
              type="text"
              value={formData.minAmount}
              onChange={(e) => handleFieldChange("minAmount", e.target.value)}
            />
          </div>
          <div className="transaction-info-item">
            <span>Max. transaction amount</span>
            <Input
              type="text"
              value={formData.maxAmount}
              onChange={(e) => handleFieldChange("maxAmount", e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="divider" />

      <div className="players-filter">
        <div className="players-filter-header">
          <h3>Players filter</h3>
          <div className="players-filter-checkbox">
            <Checkbox
              className="checkbox"
              checked={formData.applyForAllPlayers}
              onChange={(e) =>
                handleFieldChange("applyForAllPlayers", e.target.checked)
              }
            />
            <span>Apply for all players</span>
          </div>
        </div>
        <div className="transaction-info">
          <div className="transaction-info-item">
            <span>Filter by segments</span>
            <Select
              value={formData.filterSegment}
              onChange={(value) => handleFieldChange("filterSegment", value)}
              options={[
                { value: "All", label: "All" },
                { value: "Segment 1", label: "Segment 1" },
                { value: "Segment 2", label: "Segment 2" },
              ]}
            />
          </div>
          <div className="transaction-info-item">
            <span>Filter by states</span>
            <Select
              value={formData.filterState}
              onChange={(value) => handleFieldChange("filterState", value)}
              options={[
                { value: "All", label: "All" },
                { value: "State 1", label: "State 1" },
                { value: "State 2", label: "State 2" },
              ]}
            />
          </div>
        </div>
      </div>

      <div className="divider" />
      <div className="processors-container">
        {formData.processors.map((proc, index) => (
          <>
          <div className="divider"></div>
          <div className="processors" key={proc.id}>
            <h3>
              {index === 0 ? "Primary processor" : `Processor #${index + 1}`}
              {index > 0 && (
                <DeleteOutlined
                  onClick={() => removeProcessor(index)}
                  className="delete-processor-icon"
                />
              )}
            </h3>

            <div className="transaction-info">
              <div className="transaction-info-item">
                <span>Processor</span>
                <Select
                  value={proc.processor}
                  onChange={(value) =>
                    handleProcessorChange(index, "processor", value)
                  }
                  options={[
                    { value: "Finix", label: "Finix" },
                    { value: "Processor 1", label: "Processor 1" },
                    { value: "Processor 2", label: "Processor 2" },
                  ]}
                />
              </div>
            </div>

            <div className="limits">
              <h3>Limits</h3>
              <div className="players-filter-checkbox">
                <Checkbox
                  className="checkbox"
                  checked={proc.noLimits}
                  onChange={(e) =>
                    handleProcessorChange(index, "noLimits", e.target.checked)
                  }
                />
                <span>No limits</span>
              </div>
            </div>

            <div className="transaction-info">
              <div className="transaction-info-item">
                <span>Period</span>
                <Select
                  value={proc.period}
                  onChange={(value) =>
                    handleProcessorChange(index, "period", value)
                  }
                  options={[
                    { value: "Daily", label: "Daily" },
                    { value: "Weekly", label: "Weekly" },
                    { value: "Monthly", label: "Monthly" },
                  ]}
                />
              </div>
              <div className="transaction-info-item">
                <span>Min. transactions #</span>
                <Input
                  type="text"
                  value={proc.minTransactions}
                  onChange={(e) =>
                    handleProcessorChange(
                      index,
                      "minTransactions",
                      e.target.value
                    )
                  }
                />
              </div>
              <div className="transaction-info-item">
                <span>Max. total amount $</span>
                <Input
                  type="text"
                  value={proc.maxTotalAmount}
                  onChange={(e) =>
                    handleProcessorChange(
                      index,
                      "maxTotalAmount",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </div>
          </>
        ))}
      </div>

      <div className="add-processor" onClick={addProcessor}>
        <PlusOutlined className="plus-icon" />
        <span>Add processor</span>
        <div className="divider"></div>
      </div>

      <div className="footer-info">
        <Checkbox
          className="checkbox"
          checked={formData.useDefaultPriority}
          onChange={(e) =>
            handleFieldChange("useDefaultPriority", e.target.checked)
          }
        />
        <span>Use default processors priority for further transactions</span>
      </div>

      <div className="buttons">
        <button className="cancel-button" onClick={handleCancel}>
          Cancel
        </button>
        <button
          className="save-button"
          onClick={() => {
            console.log("Form Data:", formData);
            // Aqui você pode enviar os dados para sua API
          }}
        >
          Create Route
        </button>
      </div>
    </div>
  );
}

export default NewRouteModal;
